"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Month = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var DatePicker_styles_1 = require("./DatePicker.styles");
var Day_1 = require("./Day");
var DayOfWeek_1 = require("./DayOfWeek");
var utilities_1 = require("./utilities");
var Month = function (_a) {
    var month = _a.month, year = _a.year, selected = _a.selected, disableDatesBefore = _a.disableDatesBefore, disableDatesAfter = _a.disableDatesAfter, disableSpecificDates = _a.disableSpecificDates, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b;
    var weeks = (0, react_1.useMemo)(function () { return (0, utilities_1.getWeeks)(month, year); }, [month, year]);
    var daysOfWeek = (0, react_1.useMemo)(function () { return (utilities_1.DAYS_OF_WEEK.map(function (dow) { return ((0, jsx_runtime_1.jsx)(DayOfWeek_1.DayOfWeek, { label: (0, utilities_1.getDayName)(dow) }, dow)); })); }, []);
    var dayClickHandler = (0, react_1.useCallback)(function (selectedDate) {
        onChange(selectedDate);
    }, [onChange]);
    var renderDay = function (day, dayIndex) {
        var disabled = ((disableDatesBefore && (0, utilities_1.isDateBefore)(day, disableDatesBefore)) ||
            (disableDatesAfter && (0, utilities_1.isDateAfter)(day, disableDatesAfter)) ||
            (disableSpecificDates && disableSpecificDates.some(function (date) { return (0, utilities_1.isSameDate)(date, day); })));
        var firstOfMonth = new Date(year, month, 1);
        var lastOfMonth = new Date(year, month + 1, 0);
        var unavailable = ((0, utilities_1.isDateBefore)(day, firstOfMonth) ||
            (0, utilities_1.isDateAfter)(day, lastOfMonth));
        return ((0, jsx_runtime_1.jsx)(Day_1.Day, { day: day, selected: selected && (0, utilities_1.isSameDate)(day, selected), disabled: disabled, unavailable: unavailable, onClick: dayClickHandler }, dayIndex));
    };
    var weekRows = weeks.map(function (week, index) { return (
    // eslint-disable-next-line react/no-array-index-key
    (0, jsx_runtime_1.jsx)(DatePicker_styles_1.Row, { children: week.map(renderDay) }, index)); });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(DatePicker_styles_1.Row, { children: daysOfWeek }), weekRows] }));
};
exports.Month = Month;
